module.exports = __webpack_public_path__ + "static/media/icon_history.8fd031aa.svg";